















import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'

@Component({
  components: {
    PageHead,
  },
})
export default class CpdLibrary extends Vue {
  pageTitle = 'Free CPD Library'
  placeholderText = '<p>Counselling Tutor has a selection of certified CPD lectures that you can access for free as a Webhealer client. Your lectures are rotated monthly so that you have fresh learning. Each lecture carries a 1.5-hour CPD certificate. The lectures are hosted within the Counselling Tutor CPD Learning portal which you can join using the button below.</p>'
  placeholderUrl = 'https://vk229.infusionsoft.app/app/form/6b62728dd507a6251cfeffd4080424c9?cookieUUID=982a9f53-323f-497e-94a9-a829316e4ba2'
}
